
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-compare-real-estate-agents",
      function () {
        return require("private-next-pages/how-to-compare-real-estate-agents.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-to-compare-real-estate-agents"])
      });
    }
  